<template>
  <BladderChartContent
    :title="$t('text.inco_assessment').toUpperCase()"
    :observationTypeId="observationTypeId.continenceAssessment"
    :showShareBtn="p('Patients.Inco-assessment.Share')"
    :showPrintBtn="p('Patients.Inco-assessment.Print')"
  />
</template>

<script>
import { observationTypeId } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
import BladderChartContent from '@/components/patients/incoAssessment/BladderChartContent'
export default {
  data() {
    return {
      observationTypeId
    }
  },
  components: {
    BladderChartContent
  }
}
</script>
